// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_dompurify_dist_purify_js":"8cd66438383d1ceb","node_modules_canvg_dist_index_js":"0e0469c8833d85c4","node_modules_xlsx_dist_xlsx_mini_min_js":"45bd95fd672af993","node_modules_xlsx_xlsx_mjs":"d704111907ad441a"}[chunkId] + ".js";
};